import React from 'react';
import { useInView } from '../hooks/useInView';

const Beta: React.FC = () => {
  const [sectionRef, sectionInView] = useInView();

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleDemoClick = () => {
    setTimeout(() => {
      window.location.href = 'https://app.choralplayer.com/?c=MDAwMDAw';
    }, 100);
  };

  return (
    <section className="py-20 px-4 bg-gray-50">
      <div className="container mx-auto">
        <div ref={sectionRef} className="max-w-4xl mx-auto text-center">
          <div className={`inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-500 to-blue-700 text-white rounded-full text-sm font-semibold mb-8 ${sectionInView ? 'animate-fade-up' : 'opacity-0'}`}>
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
            Currently in Beta
          </div>

          <h2
            className={`text-4xl md:text-5xl font-bold mb-6 ${sectionInView ? 'animate-fade-up' : 'opacity-0'}`}
            style={{ animationDelay: sectionInView ? '120ms' : undefined }}
          >
            <span className="text-gray-800">ChoralPlayer is</span>
            <span className="gradient-text"> Evolving</span>
          </h2>

          <p
            className={`text-xl text-gray-600 mb-8 max-w-3xl mx-auto ${sectionInView ? 'animate-fade-up' : 'opacity-0'}`}
            style={{ animationDelay: sectionInView ? '220ms' : undefined }}
          >
            We're currently in beta, which means we're actively improving and expanding our platform
            based on feedback from our existing beta testers. While we continue to refine the experience,
            we're preparing for a full launch that will bring ChoralPlayer to choirs everywhere.
          </p>

          <p
            className={`text-lg text-gray-600 mb-8 max-w-3xl mx-auto ${sectionInView ? 'animate-fade-up' : 'opacity-0'}`}
            style={{ animationDelay: sectionInView ? '300ms' : undefined }}
          >
            In the meantime, you can{' '}
            <button
              onClick={handleDemoClick}
              className="gradient-text hover:opacity-80 transition-opacity cursor-pointer"
            >
              try a demo
            </button>
            {' '}of ChoralPlayer to see how it currently works.
          </p>

          <div
            className={`bg-white rounded-2xl p-8 shadow-lg border border-gray-200 ${sectionInView ? 'animate-fade-up' : 'opacity-0'}`}
            style={{ animationDelay: sectionInView ? '380ms' : undefined }}
          >
            <h3 className="text-2xl font-bold mb-4 text-gray-800">
              Interested in ChoralPlayer for Your Choir?
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              While we're not accepting new beta testers, we'd love to hear from choirs interested
              in ChoralPlayer for when we launch. Get in touch to learn more about the product
              and be notified when it's ready for your choir.
            </p>
            <button onClick={scrollToContact} className="btn btn-primary text-lg px-8 py-4">
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Beta;
